const hittersData = [
  {
    "hitter": "Rowan Masse",
    "atBats": [
      {
        "inning": 3,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 2101,
        "ev": 96.1,
        "la": 18,
        "pitchHeight": 3,
        "result": "Lineout",
        "distance": 274
      },
      {
        "inning": 5,
        "pitchType": "Slider",
        "spinRate": 2283,
        "ev": 85.3,
        "la": 2,
        "pitchHeight": 2.3,
        "result": "Foul"
      },
      {
        "inning": 5,
        "pitchType": "Changeup",
        "spinRate": 2134,
        "ev": 89.1,
        "la": 24,
        "pitchHeight": 3.2,
        "result": "Lineout",
        "distance": 321
      },
      {
        "inning": 7,
        "pitchType": "Curveball",
        "spinRate": 2404,
        "ev": 73.3,
        "la": 44,
        "pitchHeight": 2.9,
        "result": "Flyout",
        "distance": 228
      },
      {
        "inning": 9,
        "pitchType": "Sinker",
        "spinRate": 2429,
        "ev": 61.4,
        "la": 49,
        "pitchHeight": 2.4,
        "result": "Foul"
      },
      {
        "inning": 9,
        "pitchType": "Sweeper",
        "spinRate": 2589,
        "ev": 61.4,
        "la": 36,
        "pitchHeight": 2.4,
        "result": "Foul"
      }
    ]
  },
  {
    "hitter": "Michael Whooley",
    "atBats": [
      {
        "inning": 1,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 1998,
        "ev": 94.2,
        "la": 28,
        "pitchHeight": 2.7,
        "result": "Double",
        "distance": 359
      },
      {
        "inning": 3,
        "pitchType": "Changeup",
        "spinRate": 2039,
        "ev": 78.7,
        "la": 27,
        "pitchHeight": 2.1,
        "result": "Double",
        "distance": 252
      },
      {
        "inning": 9,
        "pitchType": "Sinker",
        "spinRate": 2417,
        "ev": 88,
        "la": -22,
        "pitchHeight": 2.5,
        "result": "Groundout",
        "distance": 6
      }
    ]
  },
  {
    "hitter": "Taylor Belza",
    "atBats": [
      {
        "inning": 6,
        "pitchType": "Slider",
        "spinRate": 2152,
        "ev": 96.7,
        "la": 27,
        "pitchHeight": 2.2,
        "result": "Foul"
      },
      {
        "inning": 8,
        "pitchType": "Curveball",
        "spinRate": 2815,
        "ev": 97.5,
        "la": 30,
        "pitchHeight": 2.8,
        "result": "Flyout",
        "distance": 351
      }
    ]
  },
  {
    "hitter": "Evin Sullivan",
    "atBats": [
      {
        "inning": 7,
        "pitchType": "Sinker",
        "spinRate": 2453,
        "ev": 60.8,
        "la": 37,
        "pitchHeight": 2.2,
        "result": "Foul"
      }
    ]
  },
  {
    "hitter": "Aaron Graeber",
    "atBats": [
      {
        "inning": 1,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 2203,
        "ev": 81.2,
        "la": 24,
        "pitchHeight": 3.4,
        "result": "Single",
        "distance": 275
      },
      {
        "inning": 6,
        "pitchType": "Slider",
        "spinRate": 2216,
        "ev": 88.8,
        "la": 46,
        "pitchHeight": 1.3,
        "result": "Flyout",
        "distance": 268
      },
      {
        "inning": 8,
        "pitchType": "Slider",
        "spinRate": 2709,
        "ev": 90.8,
        "la": -11,
        "pitchHeight": 1.5,
        "result": "Groundout",
        "distance": 11
      }
    ]
  },
  {
    "hitter": "Jakob Poturnak",
    "atBats": [
      {
        "inning": 3,
        "pitchType": "Slider",
        "spinRate": 2220,
        "ev": 95.1,
        "la": 46,
        "pitchHeight": 2.9,
        "result": "Flyout",
        "distance": 269
      },
      {
        "inning": 7,
        "pitchType": "Curveball",
        "spinRate": 2505,
        "ev": 47.8,
        "la": -81,
        "pitchHeight": 2.4,
        "result": "Groundout",
        "distance": 3
      }
    ]
  },
  {
    "hitter": "Carsten Sabathia III",
    "atBats": [
      {
        "inning": 2,
        "pitchType": "Changeup",
        "spinRate": 2006,
        "ev": 99.1,
        "la": 32,
        "pitchHeight": 2.8,
        "result": "Flyout",
        "distance": 364
      },
      {
        "inning": 4,
        "pitchType": "Slider",
        "spinRate": 2108,
        "ev": 63.2,
        "la": 74,
        "pitchHeight": 1.7,
        "result": "Foul"
      },
      {
        "inning": 4,
        "pitchType": "Slider",
        "spinRate": 2275,
        "ev": 80,
        "la": 57,
        "pitchHeight": 2.5,
        "result": "Foul"
      },
      {
        "inning": 4,
        "pitchType": "Slider",
        "spinRate": 2203,
        "ev": 102.4,
        "la": 24,
        "pitchHeight": 1.8,
        "result": "Home Run",
        "distance": 382
      }
    ]
  },
  {
    "hitter": "John Schroeder",
    "atBats": [
      {
        "inning": 1,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 2029,
        "ev": 80.9,
        "la": 65,
        "pitchHeight": 3.2,
        "result": "Pop Out",
        "distance": 138
      }
    ]
  },
  {
    "hitter": "JuJu Stevens",
    "atBats": [
      {
        "inning": 7,
        "pitchType": "Sinker",
        "spinRate": 2309,
        "ev": 101.1,
        "la": 32,
        "pitchHeight": 3.3,
        "result": "Double",
        "distance": 368
      },
      {
        "inning": 9,
        "pitchType": "Sinker",
        "spinRate": 2437,
        "ev": 68.5,
        "la": 2,
        "pitchHeight": 3.4,
        "result": "Ball"
      },
      {
        "inning": 9,
        "pitchType": "Sinker",
        "spinRate": 2440,
        "ev": 96.9,
        "la": 41,
        "pitchHeight": 2.9,
        "result": "Flyout",
        "distance": 342
      }
    ]
  },
  {
    "hitter": "Jaden Sheffield",
    "atBats": [
      {
        "inning": 4,
        "pitchType": "Four-Seam Fastball",
        "spinRate": 2120,
        "ev": 80.2,
        "la": 70,
        "pitchHeight": 1.4,
        "result": "Pop Out",
        "distance": 99
      },
      {
        "inning": 6,
        "pitchType": "Curveball",
        "spinRate": 2417,
        "ev": 64.9,
        "la": -3,
        "pitchHeight": 2,
        "result": "Groundout",
        "distance": 25
      }
    ]
  }
];
export default hittersData;
